<br />
<mat-expansion-panel expanded="true">
  <mat-expansion-panel-header>
    <mat-panel-title>
      <h6 class="titulo-solicitud">Asignación Persona x Vehiculo</h6>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <div class="row">
    <div class="col s12 m12 l12">
      <form [formGroup]="personaGroup" class="example-form">
        <mat-form-field class="example-full-width">
          <input
            matInput
            placeholder="Documento, Nombre o Apelido"
            value=""
            formControlName="formPersona"
            (keydown.enter)="busqueda($event)"
          />
        </mat-form-field>
      </form>
    </div>
  </div>

  <div class="row" *ngIf="!isSelectedPersona && dataPersona.length > 0">
    <div class="col s6 m6 l6">
      <mat-list>
        <h3 mat-subheader>Personas</h3>
        <mat-list-item
          *ngFor="let item of dataPersona"
          style="cursor: pointer;"
          (click)="detallePersona(item)"
        >
          <mat-icon mat-list-icon>account_circle</mat-icon>
          <h4 mat-line>{{ item.Nombre }} {{ item.Apellido }}</h4>
          <p mat-line>{{ item.NroDocId }}</p>
        </mat-list-item>
      </mat-list>
    </div>
  </div>

  <div class="row" *ngIf="loading">
    <div class="col s6 m6 l6">
      <mat-spinner
        [diameter]="100"
        style="margin:0 auto; top:15px;"
      ></mat-spinner>
    </div>
  </div>

  <div class="row" *ngIf="isSelectedPersona">
    <div class="col s6 m6 l6">
      <mat-list *ngIf="dataPersonaVehiculo.length > 0">
        <h3 mat-subheader style="color: red;">
          Este usuario tiene un vehiculo asignado, si selecciona uno nuevo se
          reasignará
        </h3>
        <mat-list-item *ngFor="let item of dataPersonaVehiculo">
          <mat-icon mat-list-icon>swap_horiz</mat-icon>
          <h4 mat-line>{{ item.NroDocId }} -- {{ item.nombre }}</h4>
          <p mat-line>Placa: {{ item.Placa }} -- {{ item.Descripcion }}</p>
        </mat-list-item>
      </mat-list>
      <p *ngIf="tienePersonaVehiculo == 2" mat-subheader style="color: green;">
        <span style="font-weight: bolder;">{{personaSeleccionada.NroDocId}} -- {{personaSeleccionada.Nombre}} {{personaSeleccionada.Apellido}}</span>&nbsp; no tiene vehiculo asignado
      </p>
    </div>
  </div>

  <div class="row" *ngIf="tienePersonaVehiculo > 0">
      <form [formGroup]="vehiculoGroup" class="example-form">
    <div class="col s12 m6 l6">
      
        <mat-form-field class="example-full-width">
          <input
            matInput
            placeholder="Vehiculo"
            [matAutocomplete]="auto"
            formControlName="formVehiculo"
          />
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
            <mat-option
              *ngFor="let item of filteredVehiculos | async"
              [value]="item"
            >
              <span>{{ item.valor }}</span>
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>
      
    </div>
    <div class="col s12 m6 l6">
        <mat-form-field>
            <mat-label>TIPO PERSONA VEHICULO</mat-label>
            <mat-select formControlName="formTipoPersonaVehiculo" (valueChange)="selectChange($event);">
              <mat-option *ngFor="let item of tipoPersonaVehiculo" [value]="item.id">
                {{item.valor}}
              </mat-option>
            </mat-select>
          </mat-form-field> 
    </div>
  </form>
  </div>
  <div class="row" *ngIf="tienePersonaVehiculo > 0">
    <div class="col s12 m12 l12" style="text-align: center;">
        <button 
        mat-raised-button 
        type="button" 
        color="accent" 
        [disabled]="dataAsignacion.idPersona == '' || dataAsignacion.idVehiculo == '' || dataAsignacion.idTipoPersonaVehiculo == ''" 
        (click)="procesoPersonaVehiculo();">
          Asignar
        </button>
    </div>
  </div>
</mat-expansion-panel>

<br />
